// Approved content for the six Kolkata landing pages.
// Source: "RedMonk Wellness Kolkata_ 6 Pages Preview.html" (wording kept as approved).
// Only deliberate difference from the preview (client decision):
//  - Three references to an enquiry form replaced with call / WhatsApp wording.

export interface KolkataGroupItem { name: string; desc: string; }
export interface KolkataGroup { title: string; items: KolkataGroupItem[]; }
export interface KolkataBanner { d: string; m: string; alt: string; }

export interface KolkataPage {
  id: string;
  navName: string;
  slug: string;
  title: string;
  description: string;
  tag: string;
  h1: string;
  sub: string;
  aboutTitle: string;
  about: string[];
  seoTitle: string;
  seoParas: string[];
  groups: KolkataGroup[];
  faqs: { q: string; a: string }[];
  cta: string;
  banner: KolkataBanner | null;
  ogImage: string | null;
}

export const KOLKATA_HIGHLIGHTS: { icon: string; text: string }[] = [
  {
    "icon": "fa-user-md",
    "text": "Qualified Dermatologist Consultation"
  },
  {
    "icon": "fa-running",
    "text": "Free Physiotherapy Assessment & Consultation"
  },
  {
    "icon": "fa-clipboard-list",
    "text": "Personalised Treatment Plans"
  },
  {
    "icon": "fa-shield-alt",
    "text": "Safe & Advanced Technology"
  }
];

export const KOLKATA_STEPS: { title: string; text: string }[] = [
  {
    "title": "Book",
    "text": "Call or WhatsApp"
  },
  {
    "title": "Consult & scan",
    "text": "Doctor and skin, hair or body check"
  },
  {
    "title": "Your plan",
    "text": "Personalised, no one-size-fits-all"
  },
  {
    "title": "Treat & follow up",
    "text": "Sessions plus post-procedure review"
  }
];

export const KOLKATA_WHY_CHOOSE: { title: string; paras: string[] } = {
  "title": "Why Choose RedMonk Wellness Kolkata?",
  "paras": [
    "At RedMonk Wellness Kolkata, every plan begins with a proper consultation and ends with proper follow-up. You are seen by qualified doctors, guided by a personalised treatment plan and cared for with safe, advanced technology. Our team explains each step in simple words, so you always know what is being done and why.",
    "Treatments are advised only after consultation with our qualified doctor, and results may vary from person to person. To begin, call or WhatsApp us on +91 62-62-03-03-03."
  ]
};

export const KOLKATA_PAGES: KolkataPage[] = [
  {
    "id": "skin",
    "navName": "Skin & Facial",
    "slug": "/kolkata/dermatology-skin-facial-treatments",
    "title": "Skin Treatment & Face Glow in Kolkata | RedMonk Wellness",
    "description": "Skin treatment in Kolkata at our aesthetic clinic: face glow facials, acne care, HIFU and anti-aging, led by a dermatologist. 30% off on selected services.",
    "tag": "HEALTHY SKIN",
    "h1": "Healthy Skin, Designed by a Dermatologist",
    "sub": "From a detailed skin scan to HIFU lifting, every plan at our Kolkata clinic begins with a qualified dermatologist.",
    "aboutTitle": "Skin & Facial Treatments in Kolkata",
    "about": [
      "Your skin tells a story of sun, stress, sleep, hormones and the products you use. At RedMonk Wellness Kolkata, we begin by listening to that story. A qualified dermatologist reviews your concerns, and a machine-based skin scan helps us see what the eye alone can miss, so every recommendation is based on your skin and not on a standard package.",
      "From acne and scar care, pigmentation and anti-tan treatments to signature facials such as Hydra Facial, Medi Facial, Hollywood Peel and Oxygeneo, our range covers everyday glow as well as deeper concerns. For skin tightening and rejuvenation, we offer advanced options including HIFU for the jawline and full face, MNRF and IPL, performed on professional-grade machines.",
      "After your consultation, you receive a clear plan: what is advised, how many sessions, and what aftercare to follow. Our team stays with you through follow-ups and post-procedure reviews, so you always know how your skin is responding."
    ],
    "seoTitle": "Skin Treatments in Kolkata",
    "seoParas": [
      "Looking for a dermatologist in Kolkata who starts with your skin rather than a fixed package? At RedMonk Wellness, our clinic in Sreepally, Elgin offers dermatology consultation, a machine-based skin scan and a personalised plan for acne, scars, pigmentation, tan and early signs of ageing.",
      "From Hydra facial, Medi facial and Hollywood peel to chemical peels, IPL, MNRF and HIFU skin tightening, every treatment is chosen after the doctor understands your skin type, lifestyle and goals. We use medical-grade products and advanced machines, and we explain the process, aftercare and expected sessions before you begin.",
      "Whether you want a pre-wedding glow, help with post-acne marks or a fresh look before a festival, book a consultation at our Kolkata clinic. Ask about our 30% off on selected services."
    ],
    "groups": [
      {
        "title": "Consultation & Analysis",
        "items": [
          {
            "name": "Dermatology Consultation",
            "desc": "One-to-one visit with our qualified dermatologist"
          },
          {
            "name": "Skin Analysis / Skin Scan",
            "desc": "Machine-based face scan before any treatment"
          }
        ]
      },
      {
        "title": "Concern-Based Care",
        "items": [
          {
            "name": "Acne & Scar Treatment",
            "desc": "Calm breakouts and soften the look of marks"
          },
          {
            "name": "Pigmentation Treatment",
            "desc": "Even out dark patches and uneven tone"
          },
          {
            "name": "Anti-Tan Treatment",
            "desc": "Lift sun tan and bring back brightness"
          },
          {
            "name": "Anti-Aging Solutions",
            "desc": "Targeted care for fine lines and dullness"
          }
        ]
      },
      {
        "title": "Facials & Glow",
        "items": [
          {
            "name": "Hydra Facial / Hydra",
            "desc": "Deep cleanse, exfoliate and hydrate"
          },
          {
            "name": "Medi Facial",
            "desc": "Medical-grade facial matched to your skin"
          },
          {
            "name": "Hollywood Peel / Carbon Facial",
            "desc": "Carbon peel for clear, camera-ready skin"
          },
          {
            "name": "Gold Switch Facial",
            "desc": "A luxurious glow facial"
          },
          {
            "name": "Glow Peel",
            "desc": "Gentle peel for a fresh, radiant look"
          },
          {
            "name": "Glutathione Skin Brightening",
            "desc": "Brightening programme for luminous skin"
          },
          {
            "name": "Oxygeneo",
            "desc": "Exfoliate, infuse and oxygenate in one"
          },
          {
            "name": "Oxygen Facial",
            "desc": "Oxygen-infused facial for instant freshness"
          },
          {
            "name": "Oxyfen Therapy",
            "desc": "Oxygen-based therapy for tired skin"
          },
          {
            "name": "Red Light Therapy",
            "desc": "Light-based care for skin renewal"
          },
          {
            "name": "Face Meso",
            "desc": "Nutrient meso facial for glow"
          },
          {
            "name": "GFC Face",
            "desc": "Growth-factor facial for rejuvenation"
          },
          {
            "name": "Rejuvenation Treatments",
            "desc": "A customised skin refresh"
          }
        ]
      },
      {
        "title": "Peels",
        "items": [
          {
            "name": "LHA Peel",
            "desc": "Mild exfoliating peel"
          },
          {
            "name": "Bine / Chemical Peel",
            "desc": "Chemical peel for texture and tone"
          }
        ]
      },
      {
        "title": "Advanced Technology",
        "items": [
          {
            "name": "IPL – Short Face",
            "desc": "Light therapy for tone concerns"
          },
          {
            "name": "MNRF",
            "desc": "Microneedling with radiofrequency"
          },
          {
            "name": "HIFU – Jawline",
            "desc": "Ultrasound lifting for a sharper jawline"
          },
          {
            "name": "HIFU – Full Face",
            "desc": "Non-surgical lifting for the whole face"
          }
        ]
      }
    ],
    "faqs": [
      {
        "q": "Which treatment suits my skin?",
        "a": "That is decided after your dermatology consultation and skin scan."
      },
      {
        "q": "Is there downtime?",
        "a": "Facials usually have little; peels and advanced treatments come with aftercare guidance."
      }
    ],
    "cta": "Book your dermatologist consultation.",
    "banner": {
      "d": "assets/images/banner/Skin-Concern-Treatments.jpeg",
      "m": "assets/images/banner/Skin-Concern-Treatments-mobile-size.jpeg",
      "alt": "Skin treatment in Kolkata: a client receiving a glow facial at the RedMonk Wellness aesthetic clinic"
    },
    "ogImage": "assets/images/banner/Skin-Concern-Treatments.jpeg"
  },
  {
    "id": "hair",
    "navName": "Hair",
    "slug": "/kolkata/hair-treatments-solutions",
    "title": "Hair Treatment & Anti-Dandruff Care in Kolkata | RedMonk Wellness",
    "description": "Skin and hair clinic in Kolkata: hair scans, hair fall control, PRP, GFC, QR678, exosome therapy and anti-dandruff treatment. Book a hair consultation.",
    "tag": "STRONGER HAIR",
    "h1": "Stronger Hair, Starting at the Root",
    "sub": "We scan first, treat second. Find out why your hair is falling before choosing a treatment.",
    "aboutTitle": "Hair Treatments in Kolkata",
    "about": [
      "Hair fall is rarely caused by one thing. Stress, nutrition, hormones, scalp health and lifestyle can all play a part. That is why our hair journey starts with a detailed consultation and a hair and scalp scan, helping our doctor understand the cause before choosing a treatment.",
      "Based on your needs, your plan may include Hair Fall Control, PRP, GFC, hair mesotherapy, QR678, exosome therapy or scalp treatments for dandruff and buildup. Each option works differently, and our doctor explains what suits your stage of hair concern and what to expect.",
      "Hair treatments need patience and consistency. We schedule regular reviews to track your progress and adjust the plan when needed, so you can move towards stronger, healthier-looking hair with clear guidance throughout."
    ],
    "seoTitle": "Hair Fall Treatment in Kolkata",
    "seoParas": [
      "Hair fall can have many causes, including stress, nutrition, hormones, scalp condition and lifestyle. At RedMonk Wellness Kolkata, we start with a hair consultation and scalp scan, so the treatment matches the actual reason for your hair concern.",
      "Our hair solutions include hair fall control programmes, PRP, GFC, hair mesotherapy, QR678, exosome therapy, hair rejuvenation and scalp treatments for dandruff and scalp issues. Your doctor recommends the right combination and number of sessions, and tracks your progress at follow-ups.",
      "Results depend on the individual and take time, so we set realistic expectations from the first visit. Book a hair consultation at our Kolkata clinic and take the first step towards stronger-looking hair."
    ],
    "groups": [
      {
        "title": "Treat",
        "items": [
          {
            "name": "Hair Fall Control",
            "desc": "Structured plan to reduce shedding"
          },
          {
            "name": "PRP Hair Treatment",
            "desc": "Your own platelet-rich plasma to support follicles"
          },
          {
            "name": "GFC Hair",
            "desc": "Growth-factor therapy for thinning areas"
          },
          {
            "name": "Hair Mesotherapy",
            "desc": "Nourishing scalp micro-injections"
          },
          {
            "name": "QR678 Hair Treatment",
            "desc": "Advanced growth-support for thinning hair"
          },
          {
            "name": "Hair Rejuvenation",
            "desc": "Improve hair quality and scalp health"
          },
          {
            "name": "Exosome Therapy",
            "desc": "Next-gen regenerative hair therapy"
          },
          {
            "name": "TCL / Scalp Treatment",
            "desc": "Targeted care for dandruff and scalp issues"
          }
        ]
      }
    ],
    "faqs": [
      {
        "q": "When should I see a doctor?",
        "a": "If shedding continues for weeks, or you notice thinning or a widening parting."
      },
      {
        "q": "When will I see results?",
        "a": "Hair treatments take time; most need consistent sessions over a few months."
      }
    ],
    "cta": "Book your hair scan.",
    "banner": {
      "d": "assets/images/banner/hair-treatment.jpg",
      "m": "assets/images/banner/hair-treatment-m.jpg",
      "alt": "Hair and scalp treatment in Kolkata: a specialist treating a client’s scalp at RedMonk Wellness"
    },
    "ogImage": "assets/images/banner/hair-treatment.jpg"
  },
  {
    "id": "laser",
    "navName": "Laser",
    "slug": "/kolkata/laser-treatments",
    "title": "Laser Hair Reduction in Kolkata | Aesthetic Clinic | RedMonk",
    "description": "Laser hair reduction for hands, legs, face and full body, plus mole removal, at our aesthetic clinic in Kolkata. 30% off on selected services.",
    "tag": "LASER STUDIO",
    "h1": "Smooth, Hair-Free Skin with Advanced Laser",
    "sub": "Say goodbye to shaving and waxing with laser hair reduction planned around your skin and hair type.",
    "aboutTitle": "Laser Treatments in Kolkata",
    "about": [
      "Constant shaving, waxing and threading can be time-consuming and irritating. Laser hair reduction offers a long-term way to reduce unwanted hair, so your skin feels smoother and needs less upkeep. At RedMonk Wellness Kolkata, treatments are done on a dedicated laser hair reduction machine after a consultation to understand your skin and hair type.",
      "We offer laser hair reduction for hands and legs, a full body plan and face laser, along with precise mole removal by our doctor. Most people need a course of sessions spaced a few weeks apart, and your plan is shared clearly before you begin.",
      "Before each session, avoid waxing, threading and direct sun exposure, and tell us about your medical history and medicines. Our team will guide you on aftercare so your skin stays comfortable between sessions."
    ],
    "seoTitle": "Laser Hair Reduction in Kolkata",
    "seoParas": [
      "Laser hair reduction is a popular alternative to repeated shaving, waxing and threading. At RedMonk Wellness Kolkata, treatments are done on advanced laser machines after a consultation that checks your skin, hair type and the area to be treated.",
      "Choose from hands and legs, face, or a full body package. A course of sessions spaced a few weeks apart gives gradual reduction in unwanted hair, and our team guides you on preparation and aftercare, including sun protection. We also offer doctor-performed mole removal.",
      "Ask our team about the full body laser package and our 30% off on selected services, and book your session today."
    ],
    "groups": [
      {
        "title": "Laser Packages",
        "items": [
          {
            "name": "Laser Hair Reduction (Hands & Legs)",
            "desc": "Long-term reduction for smoother skin"
          },
          {
            "name": "Laser Hair Reduction",
            "desc": "Long-lasting reduction in unwanted hair"
          },
          {
            "name": "LHR – Full Body Package",
            "desc": "Head-to-toe coverage in one plan"
          },
          {
            "name": "Face Laser",
            "desc": "Gentle laser care for facial hair and skin"
          },
          {
            "name": "Full Body Laser",
            "desc": "Complete body treatment, planned by sessions"
          },
          {
            "name": "Mole Removal",
            "desc": "Precise removal by our doctor"
          }
        ]
      }
    ],
    "faqs": [
      {
        "q": "How many sessions are needed?",
        "a": "A course spaced a few weeks apart, based on area and hair type."
      },
      {
        "q": "Is it painful?",
        "a": "Most people feel mild discomfort; cooling technology helps."
      }
    ],
    "cta": "Book your laser session.",
    "banner": {
      "d": "assets/images/banner/Laser-&-Removal-Treatments.jpeg",
      "m": "assets/images/banner/Laser-&-Removal-Treatments-mobile-size.jpeg",
      "alt": "Laser hair reduction in Kolkata: a client wearing protective eyewear during a laser session"
    },
    "ogImage": "assets/images/banner/Laser-&-Removal-Treatments.jpeg"
  },
  {
    "id": "iv",
    "navName": "IV Wellness & Beauty",
    "slug": "/kolkata/iv-wellness-beauty",
    "title": "IV Wellness Therapy in Kolkata | Monk Series | RedMonk Wellness",
    "description": "IV wellness therapy in Kolkata: Eternal, Iron, Golden, Aqua and Monk’s Guard drips for energy, immunity and glow, after medical screening.",
    "tag": "BETTER YOU",
    "h1": "The Monk Series: IV Therapy for a Better You",
    "sub": "Signature drips for energy, immunity, hydration and glow, given only after medical screening.",
    "aboutTitle": "IV Wellness & Beauty Therapy in Kolkata",
    "about": [
      "IV therapy delivers fluids, vitamins, minerals and antioxidants directly into the bloodstream, under the care of qualified medical professionals. At RedMonk Wellness, our signature Monk series is designed around specific needs, from energy and recovery to hydration, immunity and glowing skin.",
      "Eternal Monk supports anti-ageing and longevity, Iron Monk is built for energy and performance, Monk’s Guard supports immunity, Aqua Monk helps you reset after travel or a long night, and Golden Monk is crafted for skin glow. Personalised IV wellness programs are also available after screening.",
      "Safety comes first. Every IV session begins with a medical screening and suitability assessment, because IV therapy is not right for everyone. Your doctor will decide the drip and schedule that fit your health and goals."
    ],
    "seoTitle": "IV Therapy in Kolkata: The Monk Series",
    "seoParas": [
      "IV therapy delivers fluids, vitamins and antioxidants directly into the bloodstream under medical supervision. The RedMonk Monk series covers common wellness needs: Eternal Monk for anti-ageing, Iron Monk for energy and recovery, Monk’s Guard for immunity, Aqua Monk for hydration and Golden Monk for skin glow.",
      "Every session begins with a medical screening and suitability assessment, because IV therapy is not right for everyone. Your doctor will recommend a drip or a personalised IV wellness programme based on your health history and goals.",
      "Our Kolkata clinic offers a calm, hygienic setting for your session. Call or WhatsApp us to check availability and book."
    ],
    "groups": [
      {
        "title": "Signature Monk Drips",
        "items": [
          {
            "name": "Eternal Monk (Anti-Ageing, Longevity)",
            "desc": "Revitalising blend that supports collagen and helps skin stay firm and radiant"
          },
          {
            "name": "Iron Monk (Energy, Performance, Recovery)",
            "desc": "For strength, stamina, sharper focus and all-day vitality"
          },
          {
            "name": "Monk’s Guard (Immunity, Protection)",
            "desc": "Immunity-supporting nutrients for stress and pollution"
          },
          {
            "name": "Aqua Monk (Hydration, Reset)",
            "desc": "Quick reset after travel fatigue, late nights or dehydration"
          },
          {
            "name": "Wellness & Anti-Ageing IV Therapy",
            "desc": "Whole-body wellness support"
          }
        ]
      },
      {
        "title": "Cosmetic / Beauty IV",
        "items": [
          {
            "name": "Golden Monk (Skin, Glow, Beauty)",
            "desc": "Brightens tone, reduces dullness, glow from within"
          },
          {
            "name": "Cosmetic / Beauty IV Therapy",
            "desc": "Beauty-focused drips for skin radiance"
          }
        ]
      },
      {
        "title": "For You",
        "items": [
          {
            "name": "Personalised IV Wellness Programs",
            "desc": "A plan built after your medical screening"
          }
        ]
      }
    ],
    "faqs": [
      {
        "q": "Can I get a drip without consultation?",
        "a": "No. A medical screening and suitability assessment comes first."
      },
      {
        "q": "How long does a session take?",
        "a": "Usually about 30 to 60 minutes, depending on the drip."
      }
    ],
    "cta": "Book your IV session.",
    "banner": {
      "d": "assets/images/banner/iv-wellness-beauty.jpg",
      "m": "assets/images/banner/iv-wellness-beauty-m.jpg",
      "alt": "IV wellness therapy in Kolkata: a doctor and nurse attending to clients receiving IV drips in a relaxed treatment lounge"
    },
    "ogImage": "assets/images/banner/iv-wellness-beauty.jpg"
  },
  {
    "id": "physio",
    "navName": "Physiotherapy",
    "slug": "/kolkata/physiotherapy",
    "title": "Physiotherapy in Kolkata: Free Assessment & Pain Relief",
    "description": "Physiotherapy in Kolkata with a free assessment and consultation: pain relief, post-injury recovery and improved mobility through a personalised plan.",
    "tag": "FREE ASSESSMENT",
    "h1": "Move Freely, Live Fuller",
    "sub": "Start with a free physiotherapy assessment and consultation at RedMonk Wellness Kolkata.",
    "aboutTitle": "Physiotherapy in Kolkata",
    "about": [
      "Pain, stiffness and slow recovery can hold you back from the things you enjoy. Our physiotherapy service at RedMonk Wellness Kolkata is designed to help you move comfortably again, whether you are dealing with everyday aches, recovering from an injury or wanting to improve mobility.",
      "Everything starts with a free physiotherapy assessment and consultation, where we study how you move, understand your goals and explain what is causing the problem. From this, we build a personalised physiotherapy plan covering pain relief, post-injury recovery and improved mobility.",
      "Sessions are hands-on and progress is reviewed at every stage, so the plan grows with you. As part of a wellness centre with doctors available, you also have easy access to further medical guidance if needed."
    ],
    "seoTitle": "Physiotherapy in Kolkata with Free Assessment",
    "seoParas": [
      "Back pain, neck stiffness, a sports injury or slow recovery after surgery can limit everyday life. RedMonk Wellness Kolkata offers a free physiotherapy assessment and consultation, so you understand the problem and the plan before you commit to any treatment.",
      "Our programmes focus on pain relief, post-injury recovery and improved mobility, with a personalised plan built around your goals. Progress is reviewed regularly, and exercises are explained so you can continue safely at home.",
      "As part of a wellness centre with doctors, we can also coordinate with our medical team when needed. Book your free assessment today."
    ],
    "groups": [
      {
        "title": "Physiotherapy",
        "items": [
          {
            "name": "Physiotherapy Assessment",
            "desc": "Free, thorough check of how you move"
          },
          {
            "name": "Physiotherapy Consultation",
            "desc": "Free one-to-one discussion of your goals"
          },
          {
            "name": "Pain Relief",
            "desc": "Targeted therapy for everyday aches"
          },
          {
            "name": "Post-Injury Recovery",
            "desc": "Safe rehabilitation after injury"
          },
          {
            "name": "Improved Mobility",
            "desc": "Restore movement and flexibility"
          },
          {
            "name": "Personalised Physiotherapy Plans",
            "desc": "A programme built around you"
          },
          {
            "name": "Physiotherapy Treatment",
            "desc": "Hands-on sessions with progress tracking"
          }
        ]
      }
    ],
    "faqs": [
      {
        "q": "Do I need a referral?",
        "a": "No. You can start with our free assessment."
      },
      {
        "q": "What should I bring?",
        "a": "Any reports, scans or prescriptions, and comfortable clothing."
      }
    ],
    "cta": "Book your FREE physio assessment.",
    "banner": {
      "d": "assets/images/banner/physiotherapy.jpg",
      "m": "assets/images/banner/physiotherapy-m.jpg",
      "alt": "Physiotherapy in Kolkata: a physiotherapist guiding a patient through a shoulder stretch for pain relief and recovery"
    },
    "ogImage": "assets/images/banner/physiotherapy.jpg"
  },
  {
    "id": "care",
    "navName": "Consultation & Care",
    "slug": "/kolkata/consultation-wellness-programs",
    "title": "Medical Wellness Services in Kolkata | Consultation & Programs",
    "description": "Medical wellness services in Kolkata: doctor consultation, vital assessment, personalised wellness programs and memberships at a beauty and wellness clinic.",
    "tag": "YOUR WELLNESS, OUR PRIORITY",
    "h1": "Your Wellness, Our Priority",
    "sub": "From first consultation to follow-up, every step of your journey is guided by our doctors.",
    "aboutTitle": "Consultation & Care in Kolkata",
    "about": [
      "Good results need good guidance. Beyond individual treatments, RedMonk Wellness Kolkata offers a complete care pathway: medical consultation, health assessment, treatment planning and follow-up, so you are never left wondering what comes next.",
      "Our doctors can conduct a medical consultation and vital assessment, screen your suitability for treatments such as IV therapy, and refer you to the right specialist when needed. Personalised wellness programs and memberships help you stay consistent with the care that matters to you.",
      "After any procedure, follow-up and maintenance sessions and post-procedure reviews help us check healing and results. Your wellness journey is a long one, and we are here for every step of it."
    ],
    "seoTitle": "Doctor Consultation & Wellness Programmes in Kolkata",
    "seoParas": [
      "Good results begin with good guidance. At RedMonk Wellness Kolkata you can meet our doctor for a medical consultation, a basic vital assessment and, where needed, specialist screening, before any treatment or IV therapy is planned.",
      "We then build a personalised wellness programme around your lifestyle and goals, with wellness memberships, follow-up and maintenance sessions, and post-procedure reviews to check healing and results.",
      "Book a consultation by call or WhatsApp, and our team will help you choose the right next step."
    ],
    "groups": [
      {
        "title": "Consult",
        "items": [
          {
            "name": "Medical Consultation",
            "desc": "One-to-one visit with our doctor"
          },
          {
            "name": "Medical Screening & Suitability Assessment for IV Therapy",
            "desc": "Safety check before any drip"
          },
          {
            "name": "Vital Assessment",
            "desc": "Basic health checks before treatment"
          },
          {
            "name": "Doctor / Specialist Screening",
            "desc": "Right specialist for your concern"
          },
          {
            "name": "Personalised Wellness Programs",
            "desc": "Plans built on your lifestyle and goals"
          },
          {
            "name": "Wellness Memberships",
            "desc": "Regular care packages"
          },
          {
            "name": "Follow-up / Maintenance Sessions",
            "desc": "Keep and build on results"
          },
          {
            "name": "Post-Procedure Review",
            "desc": "Check healing and results"
          }
        ]
      }
    ],
    "faqs": [
      {
        "q": "Do I need an appointment?",
        "a": "Appointments are recommended; walk-ins are welcome subject to availability."
      },
      {
        "q": "What does a membership include?",
        "a": "Benefits vary. Please call us for current plans."
      }
    ],
    "cta": "Book your consultation.",
    "banner": {
      "d": "assets/images/banner/ConsultationAnalysis.jpeg",
      "m": "assets/images/banner/ConsultationAnalysis-m.jpeg",
      "alt": "Medical wellness consultation in Kolkata: a doctor carrying out a skin analysis with a handheld scanner"
    },
    "ogImage": "assets/images/banner/ConsultationAnalysis.jpeg"
  }
];
